import React, { useState, useEffect } from 'react';
import { Card,  CardBody,  Col,  Row } from 'reactstrap';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { getAction } from '../../utils/ApiHandler';


const FactibilidadGerencia = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
        getConfig();
  }, []);

  const getConfig = async () => {
  const name = 'avance_factibilidadGerencia'
     try {
        document.getElementById('iFactibilidadGerencia').height = (window.innerHeight) - 162;
    
        const res = await getAction('/api/appConfigNombre_json/'+ name)
        if (!res.ok) {
          throw Error(res.statusText);
        }
        res.json()
        .then((resp => {
            if (resp.data.length === 0) {
                toast.error(<span><i className="fa fa-minus-circle"></i> No está habilitado Avance de Factibilidad Gerencia.</span>, {position: toast.POSITION.TOP_RIGHT})
                return
            }
            if (resp.data[0].config.url === "") {
                toast.warning(<span><i className="fa fa-minus-circle"></i> No está habilitado Avance de Factibilidad Gerencia.</span>, {position: toast.POSITION.TOP_RIGHT})
                return
            }
            setData(resp.data[0])
            document.getElementById('iFactibilidadGerencia').src = resp.data[0].config.url;
          })
        )
      }
      catch (err) {
        toast.error(<span><i className="fa fa-minus-circle"></i> Error al intentar obtener URL de Avance de Factibilidad Gerencia!</span>, {position: toast.POSITION.TOP_RIGHT})
      }
  }

  return (
    <div className="animated fadeIn" style={{margin: "-21px -32px 0px -32px"}}>
        <ToastContainer />
          <Row>
              <Col xs="12" lg="12">
                <Card style={{marginBottom: "0px"}}>
                  <CardBody style={{padding: "0px"}}>
                      <iframe title="tFactibilidadGerencia" id="iFactibilidadGerencia" style={{width: "100%"}}>
                      </iframe>
                  </CardBody>
                </Card>
              </Col>
          </Row>
    </div>
  );
}
  

export default FactibilidadGerencia;
